import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginService } from '@core/services/login/login.service';
import { AddressService } from '@core/services/address/address.service';
import { CartService } from '@core/services/cart/cart.service';
import { PassService } from '@core/services/pass/pass.service';
import { CustomerService } from '@core/services/customer/customer.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private addressService: AddressService,
        private cartService: CartService,
        private loginService: LoginService,
        private passService: PassService,
        private customerService: CustomerService
    ) {}

    init() {
        this.loginService.userLoginSuccess.subscribe((_customer: any) => {
            this.addressService.fetch();
            this.cartService.getCart();
            this.customerService.getBottomStripsApi();

            this.passService.resetCustomerPasses();
            this.passService.initCustomerPasses().then((isSuccess: boolean) => {
                if (isSuccess) {
                    this.cartService.updatePrices();
                }
            });

            const queryParams = this.activeRoute.snapshot.queryParams;

            const currentUrl = this.router.url.split('?')[0];
            if (queryParams.returnUrl) {
                this.router.navigateByUrl(queryParams.returnUrl);
                window.history.replaceState({}, '', currentUrl);
            }
        });
    }
}
